import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { notification } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { LoginPage } from 'pages/Auth';
import { ErrorBoundary } from 'components/common';
import WhSelector from 'pages/Auth/login/WhSelector';
import { RootState } from 'reducers/root';
import { getMessage } from 'utils';
import { doDisplayErrors } from 'reducers/app';
import { doLogout } from 'reducers/auth';
import http from 'api/http';
import Papa from 'papaparse';
import { getAppConfig, updateExchange } from 'reducers/app';
import PrivateRoute from './protected.routes';
import { appConfig } from '../config';
import { find } from 'lodash';
import moment from 'moment';

function App({ doDisplayErrors, appError, doLogout, isAuthenticated }) {
  // const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    http.configureResponse({ doDisplayErrors, doLogout, isAuthenticated });
    dispatch(getAppConfig());
    getCsvData();
  }, []);

  const fetchCsv = () => {
    return fetch(appConfig.public_csv).then(function (response) {
      let reader = response.body.getReader();
      let decoder = new TextDecoder('utf-8');

      return reader.read().then(function (result) {
        return decoder.decode(result.value);
      });
    });
  };

  const getData = (result) => {
    const today = find(result.data, (r) => {
      return r.DATE === moment().format('DD-MM-YYYY');
    });
    if (today && today.RMB_VND) {
      dispatch(updateExchange(today.RMB_VND));
    }
  };

  const getCsvData = async () => {
    let csvData = await fetchCsv();

    Papa.parse(csvData, {
      complete: getData,
      header: true,
      dynamicTyping: true,
    });
  };

  // const alert = useSelector((state: RootState) => state.alert);
  // const dispatch = useDispatch();

  // useEffect(() => {
  //     history.listen((location, action) => {
  //         // clear alert on location change
  //         dispatch(alertActions.setMessage({ message: '', type: '' }));
  //     });
  // }, []);

  const openNotification = (appError) => {
    if (appError.code < 500)
      notification.warning({
        message: getMessage('common.message.alert.title'),
        description:
          appError.code < 500
            ? appError.message
            : 'Đã xảy ra lỗi không mong đợi!',
        placement: 'bottomRight',
      });
  };

  React.useEffect(() => {
    appError && openNotification(appError);
  }, [appError]);

  return (
    <ErrorBoundary>
      <Helmet>
        <title>{appConfig.siteName}</title>
      </Helmet>
      <Router>
        <div>
          <Switch>
            <Route path="/login" component={LoginPage} />
            <Route path="/wh-selector" component={WhSelector} />
            <PrivateRoute />
          </Switch>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

const mapStateToProps = (stores: RootState, props) => {
  return {
    appError: stores.app.error,
    isAuthenticated: !!stores.auth.accessToken,
  };
};

const mapDispatchToProps = {
  doDisplayErrors,
  doLogout,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
